package com.wintermar.inspection.navigation

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_inspection
import inspection.composeapp.generated.resources.ic_logout
import inspection.composeapp.generated.resources.ic_template

@Composable
fun Route.toContentModel(
    color: ThemeColor = LocalAppTheme.current.color
): RouteContentModel? {
    return when (this) {
        Route.Template -> RouteContentModel(
            title = "Template",
            resIcon = Res.drawable.ic_template,
            tint = color.surface.accent.teal.medium.active
        )

        Route.Inspection -> RouteContentModel(
            title = "Inspection",
            resIcon = Res.drawable.ic_inspection,
            tint = color.surface.accent.magenta.medium.active
        )

        Route.Logout -> RouteContentModel(
            title = "Log Out",
            resIcon = Res.drawable.ic_logout,
            tint = color.icon.error.default
        )

        else -> null
    }
}
